/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { IconFilter } from "@tabler/icons-react";
// Clear is required
type FilterHeading = {
  id: number | string;
  type: string;
  value?: string;
};

type Props = {
  filterheadings: FilterHeading[];
  value?: string;
  setValue?: (v: string | undefined) => void;
  triggerClassName?: string;
  iconSize?: number;
};

export default function DropdownFilter({
  filterheadings,
  value,
  setValue,
  triggerClassName,
  iconSize,
}: Props) {
  const [open, setOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string>("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFilterClick = (type: FilterHeading) => {
    setSelectedFilter(type?.type === "Clear" ? "Filter" : type?.type);
    setValue && setValue(type?.value);
    setOpen(false);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div
        onClick={() => setOpen((prev) => !prev)}
        className={triggerClassName || "border-[0.5px] border-[#D8D8D8] bg-white rounded-md p-1 cursor-pointer text-sm text-[#212121]"}
      >
        <IconFilter size={iconSize || 22} stroke={1.5} />
        {/* <span>{value ? value : selectedFilter}</span> */}
      </div>

      {open && (
        <div className="absolute mt-2 right-0 bg-white border border-gray-200 shadow-md rounded-md w-fit z-50">
          <div>
            {filterheadings.map((h) => (
              <label
                key={h.id}
                onClick={() => handleFilterClick(h)}
                className="space-x-2 flex items-center cursor-pointer border-b border-[#d2d2d2] px-3 py-2.5 hover:bg-[#FBD037]/10 last:border-none text-sm whitespace-nowrap"
              >
                {h.type}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
